import React, { useContext } from 'react';
import { CartContext } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
import '../css/cart.css'; // Separate CSS file import

export default function CartPage() {
  const { cartItems, removeFromCart, addToCart } = useContext(CartContext);
 

  const getCleanImage = (imgData) => {
    if (!imgData) return 'placeholder.jpg';
    if (Array.isArray(imgData)) return imgData[0] || 'placeholder.jpg';
    try {
      const parsed = JSON.parse(imgData);
      if (Array.isArray(parsed)) return parsed[0] || 'placeholder.jpg';
    } catch (e) {}
    if (typeof imgData === 'string' && imgData.includes(',')) {
      return imgData.split(',')[0].trim();
    }
    return String(imgData).replace(/[\[\]"]/g, "").trim() || 'placeholder.jpg';
  };

  // Calculations for Price Details box
  const totalItemsCount = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
  const originalTotalPrice = cartItems.reduce((acc, item) => acc + (Number(item.price || item.Price || 999) * 1.5 * (item.quantity || 1)), 0);
  const currentTotalPrice = cartItems.reduce((acc, item) => acc + (Number(item.price || item.Price || 0) * (item.quantity || 1)), 0);
  const totalDiscount = Math.round(originalTotalPrice - currentTotalPrice);
  const platformFee = cartItems.length > 0 ? 9 : 0;
  const finalAmount = currentTotalPrice + platformFee;
  const totalSavings = totalDiscount + 15; // Example coupon discount matching UI
  const navigate= useNavigate("");

  return (
    <div className="cart-page-wrapper">
      {cartItems.length === 0 ? (
        <div className="empty-cart-container">
          <h2>Your Shopping Cart is Empty</h2>
          <p>Explore our wide range of products and start shopping now.</p>
          <button className="shop-now-btn" onClick={()=>navigate("/checkout")}>Shop Now</button>
        </div>
      ) : (
        <div className="cart-main-layout">
          
          {/* LEFT SECTION: Delivery Address & Cart Items */}
          <div className="cart-left-section">
            
            {/* Delivery Pincode Box */}
            <div className="cart-address-box">
              <span className="address-label">From Saved Addresses</span>
              <button className="pincode-btn">Enter Delivery Pincode</button>
            </div>

            {/* Cart Items List */}
            <div className="cart-items-container">
              {cartItems.map(item => {
                const itemId = item.id || item.Product_ID;
                const itemPrice = Number(item.price || item.Price || 135);
                const originalPrice = Math.round(itemPrice * 1.5);

                return (
                  <div key={itemId} className="cart-item-card">
                    <div className="cart-item-info">
                      <div className="cart-img-box">
                        <img src={getCleanImage(item.images || item.Images)} alt={item.title || item.Title} />
                      </div>
                      <div className="cart-details-box">
                        <h4 onClick={() => navigate(`/product/${itemId}`)}>{item.title || item.Title}</h4>
                        <span className="cart-item-sub">Pack of 1 | {item.sub_category || 'Fashion & Accessories'}</span>
                        
                        <div className="cart-rating-row">
                          <span className="rating-badge">3.9 ★</span> <span className="rating-count">(634)</span>
                        </div>

                        <div className="cart-pricing-row">
                          <span className="discount-badge">86% off</span>
                          <span className="strike-price">₹{originalPrice}</span>
                          <span className="current-price">₹{itemPrice}</span>
                        </div>
                        <div className="wow-deal-text">⚡ Buy at ₹{itemPrice - 7} with offers</div>
                      </div>
                    </div>

                    <div className="cart-delivery-info">
                      Delivery by Tue Aug 18
                    </div>

                    <div className="cart-item-actions">
                      <div className="qty-selector">
                        <span>Qty: </span>
                        <select value={item.quantity || 1} onChange={(e) => {}}>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                        </select>
                      </div>
                      <button className="action-link-btn">Save for later</button>
                      <button className="action-link-btn" onClick={() => removeFromCart(itemId)}>Remove</button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* RIGHT SECTION: Price Details Box */}
          <div className="cart-right-section">
            <div className="price-details-card">
              <h3>Price Details</h3>
              <div className="price-row">
                <span>Price ({totalItemsCount} item{totalItemsCount > 1 ? 's' : ''})</span>
                <span>₹{Math.round(originalTotalPrice)}</span>
              </div>
              <div className="price-row">
                <span>Discount</span>
                <span className="text-success">- ₹{totalDiscount}</span>
              </div>
              <div className="price-row">
                <span>Coupons for you</span>
                <span className="text-success">- ₹15</span>
              </div>
              <div className="price-row">
                <span>Platform Fee</span>
                <span>₹{platformFee}</span>
              </div>
              
              <div className="price-divider"></div>

              <div className="price-row total-row">
                <span>Total Amount</span>
                <span>₹{finalAmount}</span>
              </div>

              <div className="savings-highlight-box">
                🎉 You'll save ₹{totalSavings} on this order!
              </div>
            </div>

            <div className="secure-badge-box">
              <span>🛡️ Safe and secure payments. Easy returns. 100% Authentic products.</span>
            </div>

            <div className="place-order-wrapper">
              <div className="place-order-pricing">
                <span className="old-total">₹{Math.round(originalTotalPrice)}</span>
                <span className="new-total">₹{finalAmount}</span>
              </div>
              <button className="place-order-btn" onClick={() =>navigate("/checkout")}>
                Place Order
              </button>
            </div>
          </div>

        </div>
      )}
    </div>
  );
}